<template>
	<div class="grade-management-box">
		<!-- 年级管理 -->
		<div class="nianji-box" v-if="!GradeManagementShow">
			<div class="fuzzy-matching-content">
				<el-button type="primary" @click="AddClick">新增年级</el-button>
				<el-button type="primary" @click="fanhui">返回</el-button>
			</div>
			<div class="fuzzy-matching-bottom">
				<el-table v-loading="loading" :border="true" class="table-Style" stripe
					:header-cell-style="{ background: '#F4F7FC', color: '#000', }" ref="multipleTable" :data="tableData"
					tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
					<el-table-column prop="name" label="名称">
					</el-table-column>
					<el-table-column prop="classCount" label="班级数量">
					</el-table-column>
					<el-table-column prop="studentCount" label="学生人数">
					</el-table-column>
					<el-table-column prop="teacherCount" label="教师人数">
					</el-table-column>
					<el-table-column prop="created" label="添加时间">
					</el-table-column>
					<el-table-column label="操作" min-width="200">
						<template #default="scope">
							<el-button type="text" size="small" class="searchBtn "
								@click="settingGrandsTeacher(scope.row)">设置年级主任</el-button>
							<el-button type="text" size="small" class="searchBtn"
								@click="classManagement(scope.row)">班级管理</el-button>
							<el-button type="text" size="small" class="searchBtn"
								@click="xiugaiClick(scope.row)">修改</el-button>
							<el-button type="text" class="shanchuBtn" size="small"
								@click="deleteClick(scope.row)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="zuzhiblock-fenye">
				<el-pagination layout="prev, pager, next, jumper" :total="total" @size-change="handleSizeChange"
					@current-change="handleCurrentChange" />
			</div>
		</div>
		<el-dialog class="dia-log-box" :title="title" v-model="dialogVisible" width="30%" :before-close="handleClose">
			<el-form ref="form" :model="form" :rules="rules">
				<el-form-item label="名称:" prop="schoolName" label-width="100px">
					<el-input v-model="form.schoolName" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="备注:" label-width="100px">
					<el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form.remark">
					</el-input>
				</el-form-item>
				<div class="buttom-box">
					<el-button type="primary" class="addForm" @click="onSubmit('form')">提交</el-button>
					<el-button @click="handleClose">返回</el-button>
				</div>
			</el-form>

		</el-dialog>
		<GradeManagement v-if="GradeManagementShow" :ClassObj="ClassObj" @banjifanhui="banjifanhui"></GradeManagement>
		
		<el-dialog class="dia-log-box" title="设置年级主任" v-model="dialogSTVisible" width="30%" :before-close="handleSTClose">
			<el-form ref="grandsDformDform" :model="grandsDformDform">
				<el-form-item v-for="(item, index) in subjectList" :key="index" :label="item.name" label-width="200">
					<el-select v-model="grandsDformDform[item.id]" filterable placeholder="请选择年级主任" multiple>
						<el-option v-for="item in teacheerList" :key="item.id" :label="item.name + ' | ' + item.mobile" :value="item.type + '|' + item.id"></el-option>
					</el-select>
				</el-form-item>
				<div class="buttom-box">
					<el-button type="primary" class="addForm" @click="onSubmitST">提交</el-button>
					<el-button @click="handleSTClose">返回</el-button>
				</div>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	import { ElMessage } from 'element-plus'
	import GradeManagement from '../class-management/index.vue'
	import {
		schoolOrUserGradeInfo,
		addGrade,
		getGradeList,
		updateaddGrade,
		teaddGradeDlete,
		getTeacherList,
		getTeacherSubject
	} from '@/assets/api/renyuan';
	
	import {addTeacherJob} from '@/assets/api/schoollog'
	
	export default {
		components: {
			GradeManagement
		},
		props: ['gradeObj'],
		data() {
			return {
				tableData: [],
				loading: true,
				pageInfo: {
					pageSize: "10",
					page: "1",
				},
				total: '',
				form: {
					remark: "",
					schoolName: ''
				},
				gradeId: '',
				schoolId:'',
				ClassObj: {},
				rules: {
					schoolName: [{
						required: true,
						message: '请输入名称',
						trigger: 'blur'
					}, ],
				},
				title: '新增年级',
				dialogVisible: false,
				GradeManagementShow: false,
				grandsDformDform:{},
				dialogSTVisible :false,
				subjectList:[],
				teacheerList:[],
			};
		},
		created() {},
		mounted() {
			this.gradeListliebiao()

		},
		methods: {
			//年级列表
			gradeListliebiao() {
				const params = {
					page: this.pageInfo.page,
					pageSize: this.pageInfo.pageSize
				}
				getGradeList(params, this.gradeObj.id).then((res) => {
					this.tableData = res.data.data.list;
					this.total = res.data.data.total
					this.loading = false;
				}).catch((err) => {
					console.log(err, '年级列表');
				})
			},
			banjifanhui() {
				this.GradeManagementShow = false

			},
			fanhui() {
				this.$emit('niajifanhui')
			},
			handleClose() {
				this.dialogVisible = false
				this.gradeListliebiao()
			},
			
			handleSTClose(){
				this.dialogSTVisible = false
				this.grandsDformDform = {};
			},

			//设置年级管理员
			settingGrandsTeacher(item) {
				this.schoolId = item.schoolId;
				this.gradeId = item.id;
				this.subjectList = [{id: "0",name: '年级主任'}];
				this.getTeacherList();
				this.getTeacherSubject();
				this.dialogSTVisible = true;
			},

			getTeacherSubject() {
				getTeacherSubject(this.gradeId).then((res) => {
					const teacherList = res.data.data;
					console.log(JSON.stringify(teacherList));
					if (teacherList != null) {
						let dataList = [];
						teacherList.forEach((item) => {
							let dataItem = {};
							let teacherItem = [];
							item.teacherList.forEach((tL) => {
								teacherItem.push(`${tL.type}|${tL.id}`)
							});
							if (item.subjectId == null || item.subjectName == null) {
								dataItem = {"0": teacherItem};
								dataList = {...dataList,...dataItem}
								this.grandsDformDform = dataList;
								return;
							}
						})
					}
				}).catch((err) => {
					this.$message({
						type: 'error',
						message: err.response.data.msg
					});
				})
			},

			onSubmitST() {
				console.log(this.grandsDformDform);
				const teacherList = this.convertJsonToSubjectTeacher(this.grandsDformDform);
				const params = [];
				const jobOrgMap = { 1: { job: 1}, 2: { job: 2}, 3: { job: 3}, 4: { job: 4}};
				teacherList.forEach((item) => {
					const [type, teacherId] = item.teacherId.split("|");
					const config = jobOrgMap[type];
					if (config && teacherId) {
						params.push({
							job: "2",
							orgId: this.gradeId,
							subject: item.subject == 0 ? undefined : item.subject,
							teacherId
						});
					}
				});
				addTeacherJob(params).then((res) => {
					this.handleSTClose();
					this.$message({
						type: 'success',
						message: "设置成功"
					});
				}).catch((err) => {
					this.$message({
						type: 'error',
						message: err.response.data.msg
					});
				})
			},


			convertJsonToSubjectTeacher(jsonData) {
				const result = [];
				for (const [key, values] of Object.entries(jsonData)) {
					// 遍历每个键对应的所有值
					values.forEach(value => {
						result.push({
							subject: key,
							teacherId: value
						});
					});
				}
				return result;
			},

			getTeacherList() {
				//获取老师列表
				const params = {
					name: "",
					schoolId: this.schoolId
				}
				getTeacherList(params).then((res) => {
					this.teacheerList = res.data.data;
				}).catch((err) => {
					this.$message({
						type: 'error',
						message: err.response.data.msg
					});
				})
			},

			onSubmit(formName) {
				// console.log(formName);
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.title == '修改年级') {
							console.log('修改', 8888);
							this.addGradeXiugai()
						} else if (this.title == '新增年级') {
							this.addGradeXinzeng()
						}
					} else {
						console.log('校验不通过');
					}

				});
			},
			AddClick() {
				this.title = '新增年级'
				this.dialogVisible = true
				console.log(8888888);

			},
			// 班级管理
			classManagement(item) {
				this.ClassObj = item
				this.GradeManagementShow = true
				// console.log(item, '班级管理');
			},
			// 修改详情
			xiugaiClick(item) {
				this.title = '修改年级'
				this.dialogVisible = true
				schoolOrUserGradeInfo(item.id).then((res) => {
					console.log(res);
					this.form.schoolName = res.data.data.name
					this.form.remark = res.data.data.description
					this.gradeId = res.data.data.id
				}).catch((err) => {
					console.log(err, 'xiugai');

				})
			},
			// 删除
			deleteClick(item) {
				this.$confirm('确定删除该年级?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					teaddGradeDlete(item.id).then((res) => {
						this.$message({
							type: 'success',
							message: '删除成功'
						});
						this.gradeListliebiao()
					}).catch((err) => {
						this.$message({
							type: 'error',
							message: err.response.data.msg
						});

					})
				}).catch((err) => {
					this.$message({
						type: 'error',
						message: err.response.data.msg
					});
				});
			},
			// 修改接口
			addGradeXiugai() {
				const params = {
					id: this.gradeId,
					name: this.form.schoolName,
					remark: this.form.remark,
				}
				updateaddGrade(params).then((res) => {
					this.$message({
						type: 'success',
						message: "修改成功"
					});
					this.handleClose()
				}).catch((err) => {
					// console.log(err,'修改失败');
					this.$message({
						type: 'error',
						message: err.response.data.msg
					});

				})

			},
			// 新增
			addGradeXinzeng() {
				const params = {
					id: this.gradeObj.id,
					name: this.form.schoolName,
					remark: this.form.remark,
				}
				addGrade(params).then((res) => {
					// console.log(res,'新增成功');
					this.$message({
						type: 'success',
						message: "新增成功"
					});
					this.handleClose()
				}).catch((err) => {
					// console.log(err,'新增失败');
					this.$message({
						type: 'error',
						message: err.response.data.msg
					});

				})

			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.pageInfo.page = val
				this.gradeListliebiao()
			},

		},
	};
</script>

<style scoped lang="scss">
	.grade-management-box {
		height: 100%;
		background-color: #fff;
		border-radius: 15px;
		padding-top: 30px;

		.nianji-box {
			height: 100%;
		}

		.fuzzy-matching-content {
			height: 20px;
			line-height: 20px;
			margin-bottom: 30px;

			:deep() {
				.el-button {
					margin-left: 50px;
					font-size: 16px;
					// color: #1BC896;
					// background-color:#1BC896;
					height: 30px;

				}
			}
		}

		.fuzzy-matching-bottom {
			// position: absolute;
			height: 70%;
			overflow: auto;
			padding: 20px;

			.table-Style {
				// border-radius: 15px;
			}

			.searchBtn {
				font-size: 15px;
				font-weight: 700;
				// color: #1BC896;
			}
			.headmaster-box {
				color: #000;
				font-weight: 600;
			}
			.shanchuBtn {
				font-size: 15px;
				font-weight: 700;
				color: red;
			}

			:deep() {
				.el-table th.el-table__cell>.cell {
					height: 30px;
					line-height: 30px;
					text-align: center;
					font-size: 16px;
					font-weight: 700;
				}

				.el-table td.el-table__cell div {
					text-align: center;
					height: 40px;
					line-height: 40px;
					border: 0;
					font-size: 16px;
				}

				.el-table:not(.el-table--border) .el-table__cell {
					border: 0;
				}

				.el-button--small {
					padding-left: 19px;
				}
			}

		}

		.zuzhiblock-fenye {
			margin-left: 1000px;
			margin-top: 15px;
		}

		:deep() {
			.el-dialog {

				.el-input--small .el-input__wrapper {
					height: 35px;
					line-height: 35px;
					text-align: center;
					width: 280px;
				}

				.el-input__inner {
					// width: 10px !important;
				}

				.buttom-box {
					// text-align: center;
					margin-left: 180px;

					.addForm {
						// background-color: #1BC896;
					}


				}

				.el-form-item--small {
					width: 70% !important;
				}
			}
		}
	}
</style>